
import { useToast } from "@/components/ui/use-toast";
import { useState, useRef } from "react";

export const useUrlValidation = () => {
  const { toast } = useToast();
  const urlWarningShownRef = useRef(false);

  const validateUrl = (url: string): boolean => {
    if (!url.trim()) {
      toast({
        title: "Oops!",
        description: "Please enter a recipe URL first!",
        variant: "destructive",
      });
      return false;
    }
    
    try {
      new URL(url);
    } catch {
      toast({
        title: "Invalid URL",
        description: "Please enter a valid recipe URL starting with http:// or https://",
        variant: "destructive",
      });
      return false;
    }
    
    // Check if it's likely a recipe URL - expanded list of keywords
    const recipeKeywords = [
      'recipe', 'cooking', 'food', 'allrecipes', 'epicurious', 'foodnetwork', 
      'baking', 'thefirstyear', 'blog', 'delish', 'bonappetit', 'cookie', 
      'cake', 'kitchen', 'dessert', 'meal', 'dinner', 'lunch', 'breakfast',
      'sallys', 'tasty', 'taste', 'serious', 'eats', 'king', 'arthur'
    ];
    const urlLower = url.toLowerCase();
    const isLikelyRecipe = recipeKeywords.some(keyword => urlLower.includes(keyword));
    
    // Only show warning once per session for non-likely recipe URLs
    if (!isLikelyRecipe && !urlWarningShownRef.current) {
      urlWarningShownRef.current = true;
      toast({
        title: "Confirm Recipe URL",
        description: "This URL doesn't look like a recipe site. Make sure you're using a URL from a cooking website.",
        variant: "destructive",
      });
      
      // Reset the warning flag after some time to allow for future warnings
      setTimeout(() => {
        urlWarningShownRef.current = false;
      }, 30000); // Reset after 30 seconds
    }
    
    return true;
  };

  const resetValidationState = () => {
    urlWarningShownRef.current = false;
  };

  return { validateUrl, resetValidationState };
};
